import Joi from "joi";

export default Joi.object({
	api_key: Joi.string().required()
});
